<!-- 部门文档更多操作 -->
<template>
  <div>
    <!-- 文件夹操作菜单 -->
    <van-action-sheet :actions="folderMoreList" v-model="showFolder" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFolder" />

    <!-- 删除弹框 -->
    <van-popup v-model="showDel" round @close="showDel = false">
      <div class="modalStyle">
        <div class="text">确定要删除该文件吗？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showDel = false" />
          <van-button text="确认" type="info" round @click="confirmDel" />
        </div>
      </div>
    </van-popup>
    <!-- 重命名弹框 -->
    <van-popup v-model="renameShow" round @close="renameShow = false">
      <div class="modalRenameStyle">
        <div class="text">重命名</div>
        <van-field v-model="renameValue" placeholder="请输入" clearable class="input" />
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="renameShow = false" />
          <van-button text="确认" type="info" round @click="confirmRename" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";

export default {
  components: {},
  data() {
    return {
      // 文件夹操作菜单
      folderMoreList: [],
      folderPriviList: [
        { name: "删除", Privi: this.$allPerms.DOC_DELETE },
        { name: "重命名", Privi: this.$allPerms.DOC_UPDATE }
      ],
      showFolder: false,
      Pitem: {}, // 当前操作的文档
      selectArr: [], // 选中的文档

      showDel: false, // 删除弹框
      renameShow: false, // 重命名弹框
      renameValue: "", // 重命名-名称
      renameForm: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    })
  },
  mounted() {},
  methods: {
    // 设置文件夹权限
    setFolderPrivi(items) {
      this.Pitem = items || {};
      this.folderMoreList = this.folderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.closeMoveCopy();
      this.showFolder = true;
    },
    // 关闭事件
    close() {
      this.showFolder = false;
    },
    // 关闭移动、复制
    closeMoveCopy() {
      this.moveShow = false;
      this.copyShow = false;
    },

    // 文件夹菜单事件
    selectFolder(val) {
      if (val.name == "删除") this.deleteRow();
      if (val.name == "重命名") this.rename();
    },

    // 删除
    deleteRow() {
      this.close();
      this.showDel = true;
    },
    // 确定删除
    async confirmDel() {
      const folderId = this.Pitem.permissionKey;
      await secondaryMenuService.delEnterpriseDept(folderId);
      Notify({ type: "success", message: "删除成功!" });
      this.showDel = false;
      this.$emit("toRefresh");
    },
    // 重命名
    async rename() {
      const folderId = this.Pitem.permissionKey;
      const { data } = await secondaryMenuService.queryEnterpriseDeptEdit(folderId);
      this.renameValue = data.deptCatalogue || "";
      this.renameForm = { ...data, folderId };
      this.renameForm.managerUserIds = data.userVoList?.map((item) => {
        return item.userId;
      });
      this.renameForm.names = data.userVoList?.map((ele) => ele.name).join(",");
      this.close();
      this.renameShow = true;
    },
    // 确定重命名
    async confirmRename() {
      let nameLength = this.renameValue.replace(/\s*/g, "");
      if (!nameLength) {
        return Notify({ type: "warning", message: "名称不能为空且不超过80个字符" });
      }
      if (nameLength.length > 80) {
        return Notify({ type: "warning", message: "名称不能超过80个字符" });
      }
      let regExp = new RegExp('[\\\\|/:*<>?"]');
      if (regExp.test(nameLength)) {
        return Notify({ type: "warning", message: '文件夹名称不能包含以下字符:\\ / : * " ? < > |' });
      }
      // 参数
      const params = { ...this.renameForm, deptCatalogue: nameLength };
      await secondaryMenuService.updateEnterpriseDept(params);
      Notify({ type: "success", message: "重命名成功!" });
      this.renameShow = false;
      this.$emit("toRefresh");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.modalStyle {
  width: 90vw;
  padding: 3vh 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .buttonSlider {
    width: 100%;
    padding: 2vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.modalRenameStyle {
  width: 90vw;
  padding: 0 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .input {
    border: 1px solid #e5e8f1 !important;
    background: #f5f5f5;
  }

  .buttonSlider {
    width: 100%;
    padding: 3vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}
</style>
